import Zone from "@insite/client-framework/Components/Zone";
import WidgetModule from "@insite/client-framework/Types/WidgetModule";
import WidgetProps from "@insite/client-framework/Types/WidgetProps";
import { ProductListPageContext } from "@insite/content-library/Pages/ProductListPage";
import { BaseTheme } from "@insite/mobius/globals/baseTheme";
import GridContainer, { GridContainerProps } from "@insite/mobius/GridContainer";
import GridItem, { GridItemProps } from "@insite/mobius/GridItem";
import breakpointMediaQueries from "@insite/mobius/utilities/breakpointMediaQueries";
import React, { FC } from "react";
import { css } from "styled-components";

interface OwnProps extends WidgetProps { }

type Props = OwnProps;

export interface ProductListControlsContainerStylesCustom {
    container?: GridContainerProps;
    countGridItem?: GridItemProps;
    sortGridItem?: GridItemProps;
    viewSelectGridItem?: GridItemProps;
    paginationGridItem?: GridItemProps;
}

const styles: ProductListControlsContainerStylesCustom = {
    container: {
        gap: 0,
        css: css`
            & div {
                margin-top: 0;
                margin-bottom: 0;
            }
            & select {
                border: 1px solid #ccc !important;
                border-radius: 20px !important;
                height: 30px;
                padding-right: 25px !important;
                font-size: 14px !important;

                ~ [class^="IconWrapper"] {
                    top: -3px;
                    right: -14px;
                    padding: 0;
                }
            }
        `,
    },
    countGridItem: {
        width: [12, 12, 6, 6, 3],
        css: css`
            align-items: center;

        `,
    },
    // show dropdown and pagination
    sortGridItem: {
        width: [12, 12, 12, 10, 5],
        css: css`
            align-items: center;
            text-align: right;
            & label {
                text-transform: uppercase;
                font-size: 14px;
                width: 48px !important;
                text-overflow: unset;  
                padding-top: 0;          
            }

            [class^="PaginationStyle"] {
                justify-content: center;
            }

            [class^="PerPageSelect"] {
                width: 120px;
                justify-content: flex-start;
                text-align: left;
                [class^="FormFieldStyle"] {
                    display: flex;
                    align-items: center;
                }
            }

            ${({ theme }: { theme: BaseTheme }) =>
                breakpointMediaQueries(theme, [
                    css`
                   [class^="PerPageSelect"] {
                        width: 30% !important;
                    }
                   `,
                    css`
                   [class^="PerPageSelect"] {
                        width: 30% !important;
                    }
                   `,
                    css`
                    [class^="PaginationStyle"] {
                        justify-content: flex-start;
                        nav {
                            justify-content: flex-end;
                        }
                    }
                    `,
                    css`
                    [class^="PaginationStyle"] {
                        justify-content: flex-start;
                    }
                    `,
                    null
                ],
                    "max",
                )}
        `,
    },
    // List and Grid view
    viewSelectGridItem: {
        width: [0, 0, 2, 2, 1],
        css: css`
            ${({ theme }: { theme: BaseTheme }) =>
                breakpointMediaQueries(theme, [
                    css`
                        display: none;
                    `,
                    css`
                        display: none;
                    `,
                    css`
                        display: none !important;
                    `,
                    css`
                        display: flex;
                        margin-left: auto !important;
                        [class^="sc"] {
                            justify-content: flex-end;
                        }
                    `,
                    null,
                ],
                    "max",
                )}
        `,
    },
    // Sort By
    paginationGridItem: {
        width: [12, 12, 6, 6, 3],
        css: css`
            & nav {
                display: none;
            }
            align-items: center;
            & label {
                text-transform: uppercase;
                font-size: 12px;
                line-height: 23px;
                overflow: visible;
            }

                ${({ theme }: { theme: BaseTheme }) =>
                breakpointMediaQueries(theme, [
                    null,
                    css`
                    margin: 15px 0 !important;
                    text-align: left !important;
                    label {
                        text-align: left;
                    }
                    `,
                    css`
                    text-align: right;
                    `,
                    css`
                    text-align: right;
                    `,
                ],
                    "max",
                )}       
        `,
    },
};

export const controlsContainerStyles = styles;

const ProductListControlsContainerCustom: FC<Props> = ({ id }) => {
    return (
        <GridContainer {...styles.container} data-test-selector="productListFilter">
            <GridItem {...styles.countGridItem}>
                <Zone contentId={id} zoneName="Content00" />
            </GridItem>
            <GridItem {...styles.paginationGridItem}>
                <Zone contentId={id} zoneName="Content01" />
            </GridItem>
            <GridItem {...styles.sortGridItem}>
                <Zone contentId={id} zoneName="Content02" />
            </GridItem>
            <GridItem {...styles.viewSelectGridItem}>
                <Zone contentId={id} zoneName="Content03" />
            </GridItem>
        </GridContainer>
    );
};

const widgetModule: WidgetModule = {
    component: ProductListControlsContainerCustom,
    definition: {
        group: "Product List",
        displayName: "List Controls Container Custom",
        allowedContexts: [ProductListPageContext],
    },
};

export default widgetModule;
